import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { CreateSubscriptionRequestBody } from "@syla/shared/types/requests/CreateSubscriptionRequest";
import { CreateSubscriptionResponse } from "@syla/shared/types/responses/CreateSubscriptionResponse";
import axios from "axios";

export const createSubscription = async (
  props: CreateSubscriptionRequestBody
): Promise<TransportType<CreateSubscriptionResponse>> => {
  const { data } = await axios.post("/plans/create-subscription", props);
  return data;
};
